import { render } from "./EditTouristDialog.vue?vue&type=template&id=6f46c742"
import script from "./EditTouristDialog.vue?vue&type=script&lang=js"
export * from "./EditTouristDialog.vue?vue&type=script&lang=js"

import "./EditTouristDialog.vue?vue&type=style&index=0&id=6f46c742&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__